import OurCustomers from './OurCustomers'

export default OurCustomers